import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from "./auth.service";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    public authService: AuthService,
    public router: Router
  ){ }

  canActivate()
    {
      if(this.authService.isLoggedIn !== true) {
        this.router.navigate(['sign-in'])
      }
      return true;
    }
  }


  //URLTREE is key to different paths?